import { Injectable } from '@angular/core';
import moment from 'moment';

// Daily quotes used to register the market context of a crypto operation
@Injectable({
  providedIn: 'root'
})
export class MarketDataService {

  // PTAX (Banco Central) selling rate; falls back to the last business day for weekends/holidays
  async getUsdBrl(date: Date): Promise<number | null> {
    const end = moment(date);
    const start = end.clone().subtract(7, 'days');
    const url = 'https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/odata/'
      + 'CotacaoDolarPeriodo(dataInicial=@dataInicial,dataFinalCotacao=@dataFinalCotacao)'
      + `?@dataInicial='${start.format('MM-DD-YYYY')}'&@dataFinalCotacao='${end.format('MM-DD-YYYY')}'`
      + '&$format=json&$orderby=dataHoraCotacao%20desc&$top=1';

    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const body = await response.json();
      return body.value?.[0]?.cotacaoVenda ?? null;
    } catch (error) {
      console.error('MarketDataService -> getUsdBrl', error);
      return null;
    }
  }

  // CoinGecko daily snapshot (00:00 UTC) of BTC price in USD
  async getBtcUsd(date: Date): Promise<number | null> {
    const url = `https://api.coingecko.com/api/v3/coins/bitcoin/history?date=${moment(date).format('DD-MM-YYYY')}&localization=false`;

    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const body = await response.json();
      return body.market_data?.current_price?.usd ?? null;
    } catch (error) {
      console.error('MarketDataService -> getBtcUsd', error);
      return null;
    }
  }
}
